import { createStore } from 'vuex'

export default createStore({
    state: {
        base_domain: null,
        subdomain: null,
        bookshelf_name: null,
        favicon: null,
        user: null,
        recent: null,
        font_size: 3,
        background_color: "white",
        font: "mincho",
        is_horizontal: 1,
        recaptcha_site_key: null,
        max_versions: null,
        max_histories: null,
        max_notes: 5,
        max_note_size: 65536,
        max_article_size: 2097152,
        max_genre: 5,
        max_background: 10,
        max_background_episode: 2,
        max_hondana: 5,
        max_backlink: 20,
        max_replies: 30,
        book_limit: 10,
        article_limit: 6,
        version: null,
        r18: false,     // 非ユーザ
        is_isolated: false,
        backgroundCallback: null,
        novelCovers: null,
        csrf_token: null,
    },
    mutations: {
        setBaseDomain(state, domain) {
            state.base_domain = domain;
        },
        // 現在のサブドメイン
        setSubdomain(state, domain) {
            state.subdomain = domain;
        },
        setBookshelfName(state, bookshelf_name) {
            state.bookshelf_name = bookshelf_name;
        },
        setFavicon(state, favicon) {
            state.favicon = favicon;
        },
        login(state, user) {
            state.user = user;
            // レイアウト設定値の更新
            this.commit("setLayout", user);
        },
        logout(state) {
            state.user = null;
        },
        setRecent(state, recent) {
            state.recent = recent;
        },
        setLayout(state, layout) {
            // レイアウト設定値の更新
            state.font_size = layout.font_size;
            state.background_color = layout.background_color;
            state.font = layout.font;
            state.is_horizontal = layout.is_horizontal;
            state.output_style = layout.output_style;
            state.sound_effect = layout.sound_effect;
            let bgcolor = "#f3f5f7";
            if (state.background_color == "black") {
                bgcolor = "#16181a";
            } else if (state.background_color == "zouge") {
                bgcolor = "#e9e4d4";
            } else if (state.background_color == "sakura") {
                bgcolor = "#fdeff2"
            } else if (state.background_color == "dreamy") {
                bgcolor = "#f3e1ff"
            } else if (state.background_color == "forest") {
                bgcolor = "#d2dacd"
            } else if (state.background_color == "cosmo") {
                bgcolor = "#b9bfe0"
            } else if (state.background_color == "metal") {
                bgcolor = "#d4d5db"
            } else if (state.background_color == "doom") {
                bgcolor = "#16151c"
            } else if (state.background_color == "rome") {
                bgcolor = "#720101"
            } else if (state.background_color == "jupiter") {
                bgcolor = "#412a14"
            } else if (state.background_color == "space") {
                bgcolor = "#030210"
            }
            $("html,body").css("backgroundColor", bgcolor);
        },
        setRecaptchaSiteKey(state, site_key) {
            state.recaptcha_site_key = site_key;
        },
        setMaxVersions(state, max_versions) {
            state.max_versions = parseInt(max_versions);
        },
        setMaxHistories(state, max_histories) {
            state.max_histories = parseInt(max_histories);
        },
        setMaxNotes(state, max_notes) {
            state.max_notes = parseInt(max_notes);
        },
        setMaxNoteSize(state, max_note_size) {
            state.max_note_size = parseInt(max_note_size);
        },
        setMaxArticleSize(state, max_article_size) {
            state.max_article_size = parseInt(max_article_size);
        },
        setMaxGenre(state, max_genre) {
            state.max_genre = parseInt(max_genre);
        },
        setMaxBackground(state, max_background) {
            state.max_background = parseInt(max_background);
        },
        setMaxBackgroundEpisode(state, max_background_episode) {
            state.max_background_episode = parseInt(max_background_episode);
        },
        setMaxHondana(state, max_hondana) {
            state.max_hondana = parseInt(max_hondana);
        },
        setMaxBacklink(state, max_backlink) {
            state.max_backlink = parseInt(max_backlink);
        },
        setMaxReplies(state, max_replies) {
            state.max_replies = parseInt(max_replies);
        },
        setVersion(state, version) {
            state.version = version;
        },
        setBookLimit(state, book_limit) {
            state.book_limit = parseInt(book_limit);
        },
        setArticleLimit(state, article_limit) {
            state.article_limit = parseInt(article_limit);
        },
        setR18(state, r18) {
            state.r18 = r18;
        },
        setIsIsolated(state, is_isolated) {
            state.is_isolated = is_isolated;
        },
        setBackgroundCallback(state, backgroundCallback) {
            state.backgroundCallback = backgroundCallback;
        },
        setNovelCovers(state, novelCovers) {
            state.novelCovers = novelCovers;
        },
        setCsrfToken(state, csrf_token) {
            state.csrf_token = csrf_token;
        },
    },
    actions: {
        async login(context) {
            const res = await axios.get("/get-auth");
            const user = res.data;
            if (user.id) {
                context.commit("login", user);
            } else {
                try {
                    for (let c of document.cookie.split(/;/)) {
                        let kv = c.split(/=/);
                        if (kv[0].trim() === "layout") {
                            let value = JSON.parse(decodeURIComponent(kv[1]));
                            context.commit("setLayout", value);
                            break;
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
            return user;
        },
        async recent(context) {
            const res = await axios.get("/get-recent");
            const recent = res.data;
            if (recent.id) {
                context.commit("setRecent", recent);
            }
            return recent;
        },
        readVersion(context) {
            let hash = null;
            try {
                $("script").each(function (i) {
                    if ($(this).attr("src")) {
                        const rs = $(this).attr("src").match(/(?:main|sub)\.js\?id=(.+)$/);
                        if (rs) {
                            hash = rs[1];
                            return false;
                        }
                    }
                });
            } catch (error) {}
            if (hash) {
                context.commit("setVersion", hash);
            }
        },
        acceptR18(context) {
            axios.post("/set-r18");
            context.commit("setR18", true);
        },
    },
    getters: {
        baseDomain(state) { return state.base_domain || ".kashi-hondana.com"; },
        subdomain(state) { return state.subdomain; },
        bookshelfName(state) {
            return state.bookshelf_name || "貸し本棚";
        },
        favicon(state) { return state.favicon; },
        user(state) {
            if (state?.user) {
                return state.user;
            }
            return null;
        },
        isGuest(state) {
            if (state.user) {
                return state.user.is_guest;
            }
            return false;
        },
        verifiedUser(state) {
            if (state.user) {
                return state.user.email_verified_at;
            }
        },
        fontSize(state) { return state.font_size; },
        backgroundColor(state) { return state.background_color; },
        font(state) { return state.font; },
        fontSize(state) {
            if (state.font_size == 1) {
                return "font-s";
            } else if (state.font_size == 2) {
                return "font-m";
            } else if (state.font_size == 3) {
                return "font-l";
            } else if (state.font_size == 4) {
                return "font-x";
            } else if (state.font_size == 5) {
                return "font-h";
            }
            return null;
        },
        is_horizontal(state) { return state.is_horizontal; },
        novelCovers(state) {
            if (state.novelCovers) {
                return state.novelCovers;
            } else {
                return [];
            }
        },
    }
});